<template>
  <div class="dummy-uploader row">
    <div class="dummy-content-list col-lg-6">
      <div
        class="dummy-list-header"
        @click="dummyListOpened = !dummyListOpened"
      >
        <label>
          Test data
          <span>({{ dummyList.length }})</span>
        </label>
        <span v-show="dummyListOpened">
          <i class="fa-light fa-chevron-up"></i>
        </span>
        <span v-show="!dummyListOpened">
          <i class="fa-light fa-chevron-down"></i>
        </span>
      </div>

      <div
        class="dummy-data-list custom-scrollbar-light"
        v-if="dummyListOpened"
      >
        <p class="text-muted no-dummy-content" v-if="dummyList.length == 0">
          {{ $t("data.no-dummy-data") }}
        </p>

        <div v-for="dummy in limitListLength" :key="dummy.id" class="dummy">
          <div class="content">
            <i class="fa-light fa-file-spreadsheet"></i>
            <div class="text-semibold dummy-name">{{ dummy.name }}</div>
          </div>
          <div
            class="trashcan"
            @click="onDeleteDummy(dummy)"
            :tooltip="$t('delete')"
            tooltip-placement="left"
          >
            <span slot="icon">
              <i class="fa-light fa-trash"></i>
            </span>
          </div>
        </div>
        <div class="showmore-wrapper" v-if="listLimit < dummyList.length">
          <span class="list-action" @click="showMore">{{
            remainingListLength > 50
              ? $t("export.show-more")
              : $t("show") +
                " " +
                remainingListLength +
                " " +
                $t("more").toLowerCase()
          }}</span>
        </div>
      </div>
    </div>

    <form @submit.stop.prevent enctype="multipart/form-data" class="col-lg-6">
      <div class="form-group">
        <label
          for="fileName"
          :class="{ hidelabel: !dummyContent.name }"
          style="margin-bottom: 0px"
          >{{ $t("dummy-uploader.file-ph") }}</label
        >
        <input
          class="form-control"
          type="text"
          name="fileName"
          id="fileName"
          :placeholder="$t('dummy-uploader.file-ph')"
          v-model="dummyContent.name"
          disabled
        />
        <input
          ref="file"
          type="file"
          name="fileInput"
          accept=".xlsx, .csv, .xls"
          class="input-file"
          @change="selectedFile"
        />
      </div>

      <div style="display: grid; grid-template-columns: auto 100px">
        <div class="d-flex buttons">
          <button
            type="button"
            class="btn btn-md btn-secondary"
            style="margin-right: 10px"
            @click="$refs.file.click()"
          >
            {{ $t("dummy-uploader.browse") }}
          </button>
          <button
            ref="submit"
            type="submit"
            class="btn btn-md btn-primary"
            :disabled="!valid"
            @click="onUpload(dummyContent)"
          >
            Upload
          </button>
        </div>
      </div>

      <p class="text-muted file-support">
        {{ $t("dummy-uploader.filesupport") }}
      </p>
      <div class="description">
        <div class="desc-text">
          <img src="@/assets/svg/info-icon.svg" alt="Instructions" />
          <a
            href="https://api.icrobotics.com/static/CAR-example.xlsx"
            target="_blank"
            >{{ $t("data.example-download") }}</a
          >
          <p class="text-muted">{{ $t("data.dummy-desc") }}</p>
        </div>
      </div>
    </form>

    <variable-mapping
      v-if="variableMapping"
      :fileData="multiFileData"
      @close="onCloseMappingSession()"
      @save-changes="onSaveMapping"
    />
  </div>
</template>

<script>
import ConfirmModal from "@/components/modals/ConfirmModal";
import VariableMapping from "@/components/VariableMapping";
export default {
  props: {
    contentSource: Object,
    currentType: Object,
    onCreate: Function,
    // dummyList: Array
  },

  data() {
    return {
      dummyContent: {
        sourceId: this.contentSource.id,
        name: "",
        file: "",
      },
      descOpened: true,
      dummyList: [],
      dummyListOpened: true,
      variableMapping: false,
      multiFileData: {},
      listLimit: 50,
    };
  },

  methods: {
    onSaveMapping() {
      this.showModal("confirm-save");
    },
    saveMapping() {
      if (
        this.multiFileData.variables.filter((v) => v.isId == true).length ==
          1 &&
        this.multiFileData.variables.filter((v) => v.isReferenceName == true)
          .length == 1
      ) {
        //Send the mapping options to the backend for process.
        this.$store
          .dispatch("handleMultiFileUpload", {
            sourceId: this.contentSource.id,
            fileData: this.multiFileData,
          })
          .then((res) => {
            this.multiUpload();
            this.showModal("confirm-upload");
          })
          .catch((e) => {
            console.log(e);
          });
      } else {
        // Give some kind of error message
      }
    },
    onCloseMappingSession() {
      this.showModal("cancel-mapping");
    },
    selectedFile() {
      if (!this.$refs.file.files[0]) {
        console.log("no file");
      } else {
        this.dummyContent.file = this.$refs.file.files[0];
        const fileName = this.dummyContent.file.name;
        let removeDot = fileName.substring(0, fileName.lastIndexOf("."));
        console.log(removeDot);
        this.dummyContent.name = removeDot;

        this.$refs.submit.focus();
      }
    },

    trashFile() {
      this.selectedFile();
      this.dummyContent.file = null;
    },

    showModal(res) {
      switch (res) {
        case "duplicate":
          this.$modal.show(
            ConfirmModal,
            {
              title: this.$t("dummy-uploader.duplicate-title"),
              description: this.$t("dummy-uploader.duplicate-desc"),
              hideCancelButton: true,
            },
            { width: 350, height: "auto" }
          );
          break;
        case "error":
          this.$modal.show(
            ConfirmModal,
            {
              title: this.$t("dummy-uploader.wrong-format-title"),
              description: this.$t("dummy-uploader.wrong-format-desc"),
              hideCancelButton: true,
            },
            { width: 350, height: "auto" }
          );
          break;
        case "confirm-save":
          this.$modal.show(
            ConfirmModal,
            {
              title: this.$t("variable-mapping.confirm-title"),
              description: this.$t("variable-mapping.confirm-description"),
              confirmButtonText: this.$t("confirm"),
              onConfirm: () => {
                this.saveMapping();
              },
            },
            { width: 350, height: "auto" }
          );
          break;
        case "confirm-upload":
          this.$modal.show(
            ConfirmModal,
            {
              title: this.$t("variable-mapping.uploading-title"),
              description: this.$t("variable-mapping.uploading-description"),
              hideCancelButton: true,
            },
            { width: 350, height: "auto" }
          );
          break;
        case "cancel-mapping":
          this.$modal.show(
            ConfirmModal,
            {
              title: this.$t("warning"),
              description: this.$t("variable-mapping.close-description"),
              confirmButtonText: this.$t("close"),
              onConfirm: () => {
                this.variableMapping = false;
                this.$store
                  .dispatch(
                    "cancelVariableMapping",
                    this.multiFileData.fileName
                  )
                  .then((res) => {
                    console.log(res);
                  });
              },
            },
            { width: 350, height: "auto" }
          );
          break;

        default:
          break;
      }
    },

    onUpload(dummyContent) {
      let dummySource = {
        file: dummyContent.file,
        name: dummyContent.name,
        sourceId: this.contentSource.id,
      };
      let findDuplicate = this.dummyList.find(
        (d) => d.name === dummySource.name
      );
      if (findDuplicate) {
        this.showModal("duplicate");
      } else {
        this.$store
          .dispatch("createDummy", dummySource)
          .then((res) => {
            if (res.isSingleProduct) {
              this.getDummyData();
              this.$emit("success");
              this.dummyContent = {
                sourceId: this.contentSource.id,
                name: "",
                file: "",
              };
            } else if (!res.isSingleProduct) {
              this.multiFileData = res;
              this.multiUpload(this.multiFileData);
            }
          })
          .catch((error) => {
            console.log(error);
            this.showModal("error");
          });
      }
    },

    getDummyData() {
      if (this.contentSource.dummy == true) {
        this.$store.dispatch("getDummyData", this.contentSource).then((res) => {
          // this.dummyList = this.$store.state.dummyData;
          this.dummyList = res;
          let uploadCount = this.dummyList.length;
          this.$emit("count-uploads", uploadCount);
          this.setExampleId();
        });
      }
    },
    changeExampleId(dummy) {
      this.contentSource.exampleId = dummy.id;
      this.$store
        .dispatch("editSource", this.contentSource)
        .then(() => {})
        .catch((error) => {
          this.error = true;
          console.log(error);
        });
    },
    setExampleId() {
      if (this.dummyList.length == 1 && this.contentSource.exampleId == "") {
        console.log(this.dummyList[0].id, "is gonna be example id");
        this.contentSource.exampleId = this.dummyList[0].id;
        console.log(this.contentSource);
        this.$store
          .dispatch("editSource", this.contentSource)
          .then(() => {
            console.log("ExampleId set!");
          })
          .catch((error) => {
            this.error = true;
            console.log(error);
          });
      }
    },
    onDeleteDummy(dummy) {
      let deleteDummyData = {
        sourceId: this.contentSource.id,
        dummy,
      };
      this.$store.dispatch("deleteDummy", deleteDummyData).then(() => {
        this.dummyList.splice(
          this.dummyList.findIndex((d) => d.id == dummy.id),
          1
        );
        this.$emit("success");
      });
    },

    multiUpload() {
      this.variableMapping = !this.variableMapping;
    },
    showMore() {
      this.listLimit = this.listLimit + 50;
    },
  },

  computed: {
    valid() {
      return this.dummyContent.name && this.dummyContent.file;
    },
    exampleData() {
      return this.dummyList.find((d) => d.id === this.contentSource.exampleId);
    },
    limitListLength() {
      return this.listLimit
        ? this.dummyList.slice(0, this.listLimit)
        : this.dummyList;
    },
    remainingListLength() {
      return this.dummyList.length - this.listLimit;
    },
  },
  created() {
    this.getDummyData();
  },
  components: {
    VariableMapping,
  },
};
</script>

<style lang="less">
.dummy-uploader {
  h3 {
    font-size: 18px;
    font-weight: normal;
  }

  form {
    .buttons {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
  }

  .input-file {
    opacity: 0;
    pointer-events: none;
    position: absolute;
    cursor: pointer;
  }

  .form-group {
    margin-top: 10px;
    padding-left: 0;
  }

  p.file-support {
    font-size: 12px;
    margin: 2px 0 6px;
  }

  .description {
    padding-left: 0;
    padding-top: 12px;
    position: relative;
    grid-row-start: 3;
    .desc-header {
      display: flex;
      flex-direction: row;
      align-items: center;
      span {
        margin-left: 10px;
      }
    }
    img {
      width: 16px;
      margin-right: 4px;
      margin-bottom: 2px;
    }
  }

  .dummy-wrapper {
    padding-left: 0;
  }

  .dummy-content-list {
    margin-top: 10px;
    padding-bottom: 12px;

    // border-bottom: 1px solid #8F979C;

    h3 {
      color: #8f979c;
      font-size: 12px;
      font-weight: bold;
      margin: 0;
    }
    p {
      margin: 0;
    }

    .dummy {
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;
      .content {
        display: flex;
        align-items: center;
        svg {
          margin-right: 15px;
        }
      }
      &:hover {
        background-color: rgba(235, 235, 235, 0.521);
      }
      &:nth-of-type(1) {
        margin-top: 2px;
      }
      &:nth-last-of-type(1) {
        margin-bottom: 10px;
      }
    }
    .dummy-data-list {
      max-height: 220px;
      overflow: auto !important;
    }
  }

  .actions {
    margin-top: 20px;
  }

  .dummy-list-header {
    margin-bottom: 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    svg {
      // margin-top: 6px;
      margin-right: 14px;
      font-size: 12px;
    }
    h3 {
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        margin-left: 4px;
      }
    }

    label {
      font-weight: bold;
      cursor: pointer;
      font-size: 12px;
      color: var(--text-grey-primary);
    }
  }
  .showmore-wrapper {
    display: flex;
    width: 100%;
    justify-content: center;
    padding-top: 10px;
  }

  .list-action {
    cursor: pointer;
    text-decoration: underline;
  }
  .example {
    // right: 40%;
    // position: absolute;
    margin-right: 12px;
    cursor: pointer;
  }
  .trashcan {
    cursor: pointer;
    position: relative;
    margin-right: 8px;
    // color: #fafafa;
    font-size: 12px;
  }

  .hover-delete {
    cursor: default;
    transition: 0.5s;
    opacity: 0;
    position: absolute;
    left: 0px;
    bottom: -10px;
    background-color: #666666;
    color: #fafafa !important;
    box-shadow: 2px 4px 4px 2px rgba(0, 0, 0, 0.041);
    padding: 5px 10px;
    transform-origin: 0;
    transform: rotate(180deg);
    transform-origin: 0;
    pointer-events: none;

    p {
      transform: rotate(180deg);
    }
  }
  .trashcan:hover > .hover-delete {
    opacity: 1;
    transition-delay: 0.3s;
  }
  .hover-delete:hover {
    opacity: 0 !important;
  }
  .hidelabel {
    opacity: 0;
  }
}
</style>